<template>
    <!-- Main content -->
    <section class="content">
        <!-- Info boxes -->
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" v-if="user">
              <el-alert
                v-if="inactiveUser"
                title="Usuario Solicitado"
                type="warning"
                description="Los datos de alta han sido enviados y se encuentran en espera de confirmación"
                show-icon>
              </el-alert>
              <el-alert
                v-if="returnedUser"
                title="Usuario Devuelto"
                type="error"
                description="Los datos de alta han sido devueltos, por favor verifique y vuelva a enviarlos"
                show-icon>
              </el-alert>
                <el-row :gutter="12" v-for="row in rowsModules" :key="row.idModule">
                    <el-col v-for="fModule in row" :key="fModule.idModule" :xs="24" :sm="24" :md="24 / row.length" class="dashboard_block" v-if="moduleVisible(fModule)">
                        <el-card shadow="always" align="center" style="min-height:350px">
                            <p><strong>
                            <img class="alignnone wp-image-238 size-full" :src="(userHasModule(fModule) && (fModule.html.inactiveCompany || !inactiveUser)) ? fModule.html.imgEnabled : fModule.html.imgDisabled" alt="" width="91" height="91" />
                            </strong></p>
                            <div :class="(userHasModule(fModule) && (fModule.html.inactiveCompany || !inactiveUser)) ? 'title' : 'title_disabled'">{{ fModule.html.title }}</div>
                            <div style="display:flex; flex-direction: column;">
                                <el-divider></el-divider>
                                <div style="display: flex; justify-content: start; align-items: center; flex-direction: column;">
                                  <div>
                                    <div style="display: flex; align-items: center; margin: 4px 0 4px 0;" v-for="link in fModule.html.links" :key="link.title">
                                      <router-link class="dashboardLink" style="display:flex; gap: 8px; align-items: center;" :tag="(userHasModule(fModule) && (fModule.html.inactiveCompany || !inactiveUser)) ? 'a' : 'span'"  :to="(userHasModule(fModule) && (fModule.html.inactiveCompany || !inactiveUser)) ? link.route : ''" @click.native="link.atClick">
                                        <!-- <i :class="(userHasModule(fModule) && (fModule.html.inactiveCompany || !inactiveUser)) ? 'arrow_icon' : 'arrow_icon_disabled'"></i> -->
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="20" height="25" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512"><g><path style="opacity:1" fill="currentColor" d="M 232.5,-0.5 C 240.167,-0.5 247.833,-0.5 255.5,-0.5C 255.5,38.8333 255.5,78.1667 255.5,117.5C 255.5,142.167 255.5,166.833 255.5,191.5C 211.44,191.016 167.44,191.516 123.5,193C 115.606,196.561 110.106,202.395 107,210.5C 106.5,225.496 106.333,240.496 106.5,255.5C 106.062,271.557 106.562,287.557 108,303.5C 111.555,310.055 116.721,314.888 123.5,318C 167.44,319.484 211.44,319.984 255.5,319.5C 255.5,344.167 255.5,368.833 255.5,393.5C 255.5,432.833 255.5,472.167 255.5,511.5C 247.833,511.5 240.167,511.5 232.5,511.5C 132.727,498.549 61.5605,446.549 19,355.5C 8.86392,330.621 2.36392,304.954 -0.5,278.5C -0.5,263.167 -0.5,247.833 -0.5,232.5C 12.4486,132.729 64.4486,61.5622 155.5,19C 180.379,8.86392 206.046,2.36392 232.5,-0.5 Z" /></g><g><path style="opacity:0.998" fill="currentColor" d="M 255.5,-0.5 C 263.167,-0.5 270.833,-0.5 278.5,-0.5C 378.271,12.4486 449.438,64.4486 492,155.5C 502.136,180.379 508.636,206.046 511.5,232.5C 511.5,247.833 511.5,263.167 511.5,278.5C 498.551,378.271 446.551,449.438 355.5,492C 330.622,502.136 304.955,508.636 278.5,511.5C 270.833,511.5 263.167,511.5 255.5,511.5C 255.5,472.167 255.5,432.833 255.5,393.5C 261.71,405.185 270.71,407.685 282.5,401C 329.03,355.469 375.863,310.303 423,265.5C 426.293,261.093 427.127,256.427 425.5,251.5C 422.887,245.372 418.887,240.205 413.5,236C 370.197,195.031 327.197,153.697 284.5,112C 272.73,103.239 263.063,105.072 255.5,117.5C 255.5,78.1667 255.5,38.8333 255.5,-0.5 Z" /></g><g><path style="opacity:1" fill="#fefefe" d="M 425.5,251.5 C 425.5,252.833 425.5,254.167 425.5,255.5C 319.167,255.5 212.833,255.5 106.5,255.5C 106.333,240.496 106.5,225.496 107,210.5C 110.106,202.395 115.606,196.561 123.5,193C 167.44,191.516 211.44,191.016 255.5,191.5C 255.5,166.833 255.5,142.167 255.5,117.5C 263.063,105.072 272.73,103.239 284.5,112C 327.197,153.697 370.197,195.031 413.5,236C 418.887,240.205 422.887,245.372 425.5,251.5 Z" /></g><g><path style="opacity:1" fill="#ddddde" d="M 425.5,251.5 C 427.127,256.427 426.293,261.093 423,265.5C 375.863,310.303 329.03,355.469 282.5,401C 270.71,407.685 261.71,405.185 255.5,393.5C 255.5,368.833 255.5,344.167 255.5,319.5C 211.44,319.984 167.44,319.484 123.5,318C 116.721,314.888 111.555,310.055 108,303.5C 106.562,287.557 106.062,271.557 106.5,255.5C 212.833,255.5 319.167,255.5 425.5,255.5C 425.5,254.167 425.5,252.833 425.5,251.5 Z" /></g></svg>
                                        <div>
                                          <span :data-cy="'lnk_' + link.title" :class="(userHasModule(fModule) && (fModule.html.inactiveCompany || !inactiveUser)) ? '' : 'link_title_disabled'" style="vertical-align:top">{{link.title}}</span>
                                          <el-badge v-if="(!link.badgeHiddenCond && userHasModule(fModule)) && (fModule.html.inactiveCompany || !inactiveUser) && link.route != '/allComments'" :hidden="link.badgeHiddenCond" :value="link.badgeValue" :max="99" />
                                          <el-badge v-if="(!badgeChatHidden && userHasModule(fModule)) && (fModule.html.inactiveCompany || !inactiveUser) && (link.route == '/allComments') " :hidden="badgeChatHidden" :value="badgeChatValue" :max="99" />
                                        </div>
                                      </router-link>
                                      <br>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
                <!-- FIN 4 BLOQUES INFERIORES DEL DASHBOARD NO PROVIDER -->
            </div>
        </div>
        <!-- MODAL POLITICA DE PAGOS -->
      <el-dialog title="Política de Pagos" :visible.sync="showModalPaymentPolicies" width="85%" :lock-scroll="true" style="margin-top:-80px">
          <iframe :src="urlPaymentPolicies" style="width:100%; height: calc(100vh - 233px);"></iframe>
        <span slot="footer" class="dialog-footer">
          <button class="btn" v-on:click="showModalPaymentPolicies = false" style="margin-top:-20px">
            Cerrar
          </button>
        </span>
      </el-dialog>
      <!-- MODAL POLITICA DE COMPRAS -->
      <el-dialog title="Política de Compras" :visible.sync="showModalBuyPolicies" width="85%" :lock-scroll="true" style="margin-top:-80px">
          <iframe :src="urlBuyPolicies" style="width:100%; height: calc(100vh - 233px;"></iframe>
        <span slot="footer" class="dialog-footer">
          <button class="btn" v-on:click="showModalBuyPolicies = false" style="margin-top:-20px">
            Cerrar
          </button>
        </span>
      </el-dialog>
      <!-- MODAL CODIGO ETICA -->
      <el-dialog title="Código de Conducta" :visible.sync="showModalEthicsPolicies" width="85%" :lock-scroll="true" style="margin-top:-80px">
          <iframe :src="urlEthicsPolicies" style="width:100%; height: calc(100vh - 233px);"></iframe>
        <span slot="footer" class="dialog-footer">
          <button class="btn" v-on:click="showModalEthicsPolicies = false" style="margin-top:-20px" data-cy="btn-cc-cerrar">
            Cerrar
          </button>
        </span>
      </el-dialog>
    </section>
    <!-- /.content -->
</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import DataTables from 'vue-data-tables'
import api from '../../api'
import apiHelper from '../helpers/apiHelper'
// import { count } from '../../filters'

Vue.use(DataTables)

export default {
  data () {
    return {
      menuBlocksGeneric: [
        {
          classEnabled: '',
          classDisabled: ''
        }
      ],
      badgeChatValue: 0,
      badgeChatHidden: true,
      inactiveUser: false,
      returnedUser: false,
      moduleLoaded: false,
      urlPaymentPolicies: '',
      urlBuyPolicies: '',
      showModalPaymentPolicies: false,
      showModalBuyPolicies: false,
      showModalEthicsPolicies: false,
      ocCount: 0,
      ocFacturarCount: 0,
      ocGestPagoCount: 0,
      docPaymentOrderCount: 0,
      docReceivedCount: 0,
      newProviderCount: 0,
      newMessages: 0,
      adminNewMessages: 0,
      urlEthicsPolicies: '',
      titles: [
        {
          prop: 'nombre',
          label: 'Título'
        },
        {
          prop: 'fecha_fin',
          label: 'Finaliza'
        }
      ]
    }
  },
  computed: {
    ...mapState([
      'user',
      'otherOperations',
      'compulsas',
      'messages',
      'provMessages'
    ]),
    menuBlocks () {
      return [
        {
          idModule: 1,
          imgEnabled: 'static/img/dashboard_icons/workflow-azul.png',
          imgDisabled: 'static/img/dashboard_icons/workflow-gris.png',
          inactiveCompany: false,
          title: 'Gestión de compulsas y licitaciones',
          links: [
            {
              route: '/compulsas',
              atClick: function () {},
              title: 'Compulsa de precios',
              badgeHiddenCond: !(this.compCount.length > 0),
              badgeValue: this.compCount.length
            },
            {
              route: '/',
              atClick: () => {
                if (!this.inactiveUser) {
                  this.showModalBuyPolicies = true
                }
              },
              title: 'Política de compras',
              badgeHiddenCond: true,
              badgeValue: 0
            }
            // {
            //   route: '/buyOrders',
            //   atClick: function () {},
            //   title: 'OC\'s adjudicadas',
            //   badgeHiddenCond: !(this.ocCount > 0),
            //   badgeValue: this.ocCount
            // }
          ]
        },
        {
          idModule: 2,
          imgEnabled: 'static/img/dashboard_icons/gestionpagos-azul.png',
          imgDisabled: 'static/img/dashboard_icons/gestionpagos-gris.png',
          inactiveCompany: false,
          title: 'Gestión de facturas',
          links: [
            {
              route: '/toBill',
              atClick: function () {},
              title: 'Carga de Facturas',
              badgeHiddenCond: this.user.isProvider ? !(this.ocFacturarCount > 0) : !(this.ocGestPagoCount > 0),
              badgeValue: this.user.isProvider ? this.ocFacturarCount : this.ocGestPagoCount
            },
            {
              route: '/prebill',
              atClick: function () {},
              title: 'Precarga de Facturas (sin OC)'
              // badgeHiddenCond: this.user.isProvider ? !(this.ocFacturarCount > 0) : !(this.ocGestPagoCount > 0),
              // badgeValue: this.user.isProvider ? this.ocFacturarCount : this.ocGestPagoCount
            },
            {
              route: '/billsManagement',
              atClick: function () {},
              title: 'Consulta de Facturas, NC, ND',
              badgeHiddenCond: this.user.isProvider ? !(this.docPaymentOrderCount > 0) : !(this.docReceivedCount > 0),
              badgeValue: this.user.isProvider ? this.docPaymentOrderCount : this.docReceivedCount
            },
            {
              route: '',
              atClick: () => {
                if (!this.inactiveUser) {
                  this.showModalPaymentPolicies = true
                }
              },
              title: 'Política de pagos',
              badgeHiddenCond: true,
              badgeValue: 0
            }
          ]
        },
        {
          idModule: 3,
          imgEnabled: 'static/img/dashboard_icons/autogestion-azul.png',
          imgDisabled: 'static/img/dashboard_icons/autogestion-gris.png',
          inactiveCompany: true,
          title: 'Autogestión',
          links: [
            {
              route: '/selfdata',
              atClick: function () {},
              title: 'Mis datos',
              badgeHiddenCond: true,
              badgeValue: 0
            },
            /*
              {
                route: '/submitDocumentation',
                atClick: function () {},
                title: this.user.isProvider ? 'Presentar documentación' : 'Documentación recibida',
                badgeHiddenCond: !(this.documentationCount.length > 0),
                badgeValue: this.documentationCount.length
              },
            */
            {
              route: '/changePsw',
              atClick: function () {},
              title: 'Cambiar clave',
              badgeHiddenCond: true,
              badgeValue: 0
            }
          ]
        },
        {
          idModule: 4,
          imgEnabled: 'static/img/dashboard_icons/chat-azul.png',
          imgDisabled: 'static/img/dashboard_icons/chat-gris.png',
          inactiveCompany: true,
          title: 'Mensajes',
          links: [
            {
              route: '/allComments',
              atClick: function () {},
              title: 'Ingresar al chat',
              badgeHiddenCondChat: ((this.user.isProvider) ? !(this.newMessages > 0) : !(this.adminNewMessages > 0)),
              badgeValue: ((this.user.isProvider) ? this.newMessages : this.adminNewMessages)
            },
            {
              route: '/news',
              atClick: () => {
                this.showModalEthicsPolicies = true
              },
              title: 'Novedades a Proveedores',
              badgeHiddenCond: true,
              badgeValue: 0
            }
          ]
        },
        {
          idModule: 5,
          imgEnabled: 'static/img/dashboard_icons/reportes-azul.png',
          imgDisabled: 'static/img/dashboard_icons/reportes-gris.png',
          inactiveCompany: false,
          title: 'Reportes',
          links: [
            {
              route: '/reports',
              atClick: function () {},
              title: 'Consultar reportes',
              badgeHiddenCond: true,
              badgeValue: 0
            }
          ]
        },
        {
          idModule: 6,
          imgEnabled: 'static/img/dashboard_icons/instructivos-azul.png',
          imgDisabled: 'static/img/dashboard_icons/instructivos-gris.png',
          inactiveCompany: true,
          title: 'Instructivos',
          links: [
            {
              route: '/manuals',
              atClick: function () {},
              title: 'Consultar instructivos ',
              badgeHiddenCond: true,
              badgeValue: 0
            },
            {
              route: '',
              atClick: () => {
                this.showModalEthicsPolicies = true
              },
              title: 'Código de conducta',
              badgeHiddenCond: true,
              badgeValue: 0
            }
          ]
        },
        {
          idModule: 7,
          imgEnabled: 'static/img/dashboard_icons/autogestionproveedores-azul.png',
          imgDisabled: 'static/img/dashboard_icons/autogestionproveedores-gris.png',
          inactiveCompany: false,
          title: 'Gestión de Proveedores',
          links: [
            {
              route: '/newProviders',
              atClick: function () {},
              title: 'Alta/Modificación de proveedores',
              badgeHiddenCond: !(this.newProviderCount > 0),
              badgeValue: this.newProviderCount
            },
            {
              route: '/ProvidersTable',
              atClick: function () {},
              title: 'Reporte información de proveedores',
              badgeHiddenCond: true,
              badgeValue: 0
            },
            {
              route: '/providers',
              atClick: function () {},
              title: 'Gestión de proveedores registrados',
              badgeHiddenCond: true,
              badgeValue: 0
            },
            {
              route: '/contacts',
              atClick: function () {},
              title: 'Gestión de usuarios',
              badgeHiddenCond: !(this.usersToActivateCount.length > 0),
              badgeValue: this.usersToActivateCount.length
            }
          ]
        }
      ]
    },
    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    },
    newProviders () {
      return this.$store.state.providers.filter(prov => prov.idCompanyStatus === '1')
    },
    usersToActivateCount () {
      return this.$store.state.contacts.filter(el => el.idProviderStatus === '1')
    },
    compCount () {
      return this.compulsas.filter(el => el.status.idLicitacionStatus === '2')
    },
    documentationCount () {
      return this.otherOperations
    },
    frontendModules () {
      let frontendModules
      if (!this.user.isProvider) {
        frontendModules = this.$store.state.frontendModules.filter(mod => mod.visibleAdmin === '1')
        frontendModules.forEach(fMod => {
          fMod.html = this.menuBlocks.find(mBlock => mBlock.idModule.toString() === fMod.idModule)
        })
        return frontendModules.sort((a, b) => a.orderAdmin > b.orderAdmin)
      } else {
        frontendModules = this.$store.state.frontendModules.filter(mod => mod.visibleProvider === '1')
        frontendModules.forEach(fMod => {
          fMod.html = this.menuBlocks.find(mBlock => mBlock.idModule.toString() === fMod.idModule)
          if (!this.moduleLoaded) {
            this.moduleProv()
            this.moduleLoaded = true
          }
        })
        return frontendModules.sort((a, b) => a.orderProvider > b.orderProvider)
      }
    },
    rowsModules () {
      return [this.frontendModules.slice(0, Math.floor(this.frontendModules.length / 2)), this.frontendModules.slice(Math.ceil(this.frontendModules.length / 2) - (this.frontendModules.length % 2))]
    },
    rolesHasModules () {
      return this.$store.state.rolesHasModules
    }
  },
  methods: {
    getDocPaymentOrderCount () {
      if (this.user.isProvider) {
        apiHelper.getTotal('buyOrderDocumentByCompany', 'idBuyOrderDocumentStatus = 4 AND idCompany =' + this.user.company.idCompany)
        .then(count => {
          this.docPaymentOrderCount = count
        })
      }
    },
    getNotificationsMessages () {
      if (this.user) return
      if (this.user.idUser) {
        api.request('GET', 'api/getMessagesNotifications?id=' + this.user.idUser)
          .then(response => {
            let data = response.data
            if (typeof data !== 'number') {
              data = 0
              this.badgeChatValue = 0
              this.badgeChatHidden = true
            } else {
              this.badgeChatValue = data
              this.badgeChatHidden = false
            }
            if (data.error) {
              return
            }
            if (data) {
              this.$store.state.countries = data
            }
          })
          .catch(error => {
            this.$store.commit('TOGGLE_LOADING')
            console.log(error)
          })
      }
    },
    getNewProviderCount () {
      apiHelper.getTotal('companyCountriesStatus', 'idCompanyStatus = 1 OR idCompanyStatus = 4')
      .then(count => {
        this.newProviderCount = count
      })
    },
    getNewMessagesCount () {
      // console.log(this.$store.state.user)
      // apiHelper.getTotal('messages', `status = 0 AND idEmisor = ${this.$store.state.user.idUser}`)
      /*  apiHelper.getTotal('messages', `status = 0 AND idReceptor = 0`)
      .then(count => {
        // this.newMessages = this.$store.state.messages.length
        this.adminNewMessages = count
      })  */
      this.adminNewMessages = this.badgeChatValue
    },
    getDocReceivedCount () {
      if (!this.user.isProvider) {
        apiHelper.getTotal('buyOrderDocument', 'idBuyOrderDocumentStatus = 1')
        .then(count => {
          this.docReceivedCount = count
        })
      }
    },
    getOcCount () {
      if (this.user.isProvider) {
        apiHelper.getTotal('buyOrder', 'statusId = 2 AND idCompany =' + this.user.company.idCompany)
        .then(count => {
          this.ocCount = count
        })
      } else {
        apiHelper.getTotal('buyOrder', 'statusId = 1')
        .then(count => {
          this.ocCount = count
        })
      }
    },
    getOcFacturarCount () {
      if (this.user.isProvider) {
        apiHelper.getTotal('buyOrder', 'statusId = 3 AND idCompany =' + this.user.company.idCompany)
        .then(count => {
          this.ocFacturarCount = count
        })
      } else {
        apiHelper.getTotal('buyOrder', 'statusId = 3')
        .then(count => {
          this.ocFacturarCount = count
        })
      }
    },
    getOcGestPagoCount () {
      if (this.user.isProvider) {
        apiHelper.getTotal('buyOrder', 'statusId = 9 AND idCompany =' + this.user.company.idCompany)
        .then(count => {
          this.ocGestPagoCount = count
        })
      } else {
        apiHelper.getTotal('buyOrder', 'statusId = 9')
        .then(count => {
          this.ocGestPagoCount = count
        })
      }
    },
    userHasModule (module) {
      let found = false
      let rolesHasThisModule = this.rolesHasModules.filter(roleMod => roleMod.idModule === module.idModule)
      this.user.roles.forEach(userRole => {
        if (rolesHasThisModule.some(roleModule => roleModule.rolesId === userRole.rolesId)) {
          found = true
          return
        }
      })
      return this.user.isProvider || found
    },
    moduleVisible (module) {
      return (this.user.isProvider && module.visibleProvider === '1') || (!this.user.isProvider && module.visibleAdmin === '1')
    },
    moduleProv () {
      if (this.user.isProvider && this.user.isAdmin === '1') {
        var gestionUsuarios = {
          route: '/contacts',
          atClick: function () {},
          title: 'Gestión de usuarios',
          badgeHiddenCond: true,
          badgeValue: 0
        }
        this.menuBlocks[2].links.push(gestionUsuarios)
      }
    },
    goToBidding (selected) {
      this.$router
      .push({'name': 'Compulsas', params: {licitacion: selected}})
    }
  },
  mounted () {
    this.timmerMessage = setInterval(() => this.getNotificationsMessages(), 1000 * 15)
    if (this.$route.query.finSolicitud === '1') {
      this.$router.push('/finSolicitud?t=' + this.$route.query.t)
    } else if (this.$route.query.i === '1') {
      this.$router.push('/pswreestablecida?e=' + this.$route.query.e)
    } else {
      if (!this.user) {
        this.$router.push('/login')
      } else if (this.user.company && (this.user.company.idCompanyDataStatus === '1')) {
        this.inactiveUser = true
        //  this.$router.push('/confirmProvider/' + this.user.company.idCompany)
      } else if (this.user.company && (this.user.company.idCompanyDataStatus === '3')) {
        this.returnedUser = true
      }
    }
  },
  unmounted () {
    if (this.timmerMessage) {
      clearInterval(this.timmerMessage)
    }
  },
  beforeUpdate () {
    /*  const usr = this.$store.state.user
    const msg = this.$store.state.messages
    let countMessages = 0
    if (msg && msg.length) {
      countMessages = msg.filter((itemMsg) => {
        if (itemMsg.idEmisor !== usr.idUser && itemMsg.idReceptor === usr.idUser) {
          return itemMsg
        }
      }).filter(item => parseInt(item.status) !== 1).length
    }
    this.newMessages = countMessages  */
    this.newMessages = this.badgeChatValue
  },
  beforeMount () {
    this.getNotificationsMessages()
    this.getOcCount()
    this.getOcFacturarCount()
    this.getOcGestPagoCount()
    this.getDocPaymentOrderCount()
    this.getDocReceivedCount()
    this.getNewProviderCount()
    this.getNewMessagesCount()
    if (this.$route.query.finSolicitud === '1') {
      this.$router.push('/finSolicitud?t=' + this.$route.query.t)
    } else if (this.$route.query.i === '1') {
      this.$router.push('/pswreestablecida?e=' + this.$route.query.e)
    } else {
      if (!this.$store.state.user) {
        this.$router.push('/login')
      }
    }
    if (this.user.company && (this.user.company.idCompanyDataStatus === '1')) {
      this.inactiveUser = true
      //  this.$router.push('/confirmProvider/' + this.user.company.idCompany)
    } else if (this.user.company && (this.user.company.idCompanyDataStatus === '3')) {
      this.returnedUser = true
    }
    // console.log(this.user.company.idCompanyDataStatus)
    // console.log('returnedUser: ' + this.returnedUser + ' inactiveUser: ' + this.inactiveUser)
    api.request('get', 'api/findConfiguration/POLPAG')
      .then(response => {
        this.urlPaymentPolicies = response.data['value']
      })
    api.request('get', 'api/findConfiguration/POLCOM')
      .then(response => {
        this.urlBuyPolicies = response.data['value']
      })
    api.request('get', 'api/findConfiguration/CODETI')
      .then(response => {
        this.urlEthicsPolicies = response.data['value']
      })
  }
}
</script>
<style>
.content{
  min-height: 80vh;
}
.info-box {
  cursor: pointer;
}
.number-box {
  max-height: 90px;
}
/*
box-shadow: #888888 1px 1px 1px 1px;
.info-box:hover {
  box-shadow: #888888 2px 2px 2px 2px;
  transform: translate(-1px, -1px);
} */

.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
  font-weight: 600;
  font-size: 16px;
}
.info-box-text {
  font-size: 16px;
  white-space: normal !important;
}
.info-box-info {
  font-size: 32px;
}
.fullCanvas {
  width: 100%;
}
.circle{
  border-radius: 45px;
}
.navbar {
    background-color: #888888;
}
.item {
   margin-top: 10px;
   margin-right: 40px;
 }
.arrow_icon {
  /* background-image: url('../../../static/img/dashboard_icons/flecha-azul.png'); */
  background-size: 20px 20px;
  height: 20px;
  width: 20px; 
  display: inline-block;
  /* Other styles here */
}
.arrow_icon_disabled {
  /* background-image: url('../../../static/img/dashboard_icons/flecha-gris.png'); */
  background-size: 20px 20px;
  height: 20px;
  width: 20px;
  display: inline-block;
  /* Other styles here */
}
.dashboard_block {
  margin-bottom: 10px;
}

.link_title_disabled {
  color: #666666;
}

.title {
  font-family: 'Helvetica';
  width: 100%;
  color: #000000;
  font-size: 20px;
  padding: 0px 15px
}

.title_disabled {
  font-family: 'Helvetica';
  width: 100%;
  color: #666666;
  font-size: 20px;
  padding: 0px 15px
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?68027526